document.addEventListener('DOMContentLoaded', function () {

    new Swiper('.okd-lp1-features .swiper', {
        loop: false,
        slidesPerView: 1,
        spaceBetween: 30,
        centeredSlides: false,
        watchSlidesProgress: true,
        pagination: {
            el: '.pagination-features',
            clickable: true,
        },
        navigation: {
            nextEl: '.nav-next-features',
            prevEl: '.nav-prev-features',
        },

        breakpoints: {
            0: {
                slidesPerView: 1,
            },

            450: {
                slidesPerView: 2,
            },

            650: {
                slidesPerView: 3,
            },

            1400: {
                slidesPerView: 4,
            },

            1650: {
                slidesPerView: 5,
            },
        },
    });

});